// tslint:disable:max-line-length

import React from 'react';

export const UtilityDirectories = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11,1v3H6v3h4V6h6v3h-6V8H6v5h4v-1h6v3h-6v-1H5V4H0V1H11z" />
    </svg>
  );
};
